// Measured history, not an ornamental sine wave. No mood numbers are exposed.
export const HISTORY_SECONDS=90;
export const HISTORY_INTERVAL=.5;
export function createMoodHistory(saved=[],time=0,value=0){
 const history=[];
 if(Array.isArray(saved))for(const p of saved.slice(-400)){
  if(!p||!Number.isFinite(p.t)||!Number.isFinite(p.v)||p.t<Math.max(0,time-HISTORY_SECONDS-1)||p.t>time||Math.abs(p.v)>1)continue;
  if(history.length&&p.t<history.at(-1).t)continue;
  history.push({t:p.t,v:p.v});
 }
 if(!history.length)history.push({t:time,v:value});
 return history;
}
export function recordMoodHistory(history,time,value,{force=false}={}){
 if(!Number.isFinite(time)||!Number.isFinite(value))return;
 const last=history.at(-1);
 if(last&&time<last.t)return;
 if(!last||force||time-last.t>=HISTORY_INTERVAL-1e-8){
  if(!last||last.t!==time||last.v!==value)history.push({t:time,v:Math.max(-1,Math.min(1,value))});
 }
 while(history.length>2&&history[1].t<time-HISTORY_SECONDS)history.shift();
 if(history.length>400)history.splice(0,history.length-400);
}
export function moodHistoryPlot(history,time,value,width=196,height=54){
 const span=Math.min(HISTORY_SECONDS,Math.max(15,time-(history[0]?.t??time))),start=time-span,pad=4;
 const points=history.filter(p=>p.t>=start).map(p=>({x:pad+(p.t-start)/span*(width-pad*2),y:height/2-p.v*(height/2-7)}));
 const prior=[...history].reverse().find(p=>p.t<start);
 if(prior&&points.length)points.unshift({x:pad,y:height/2-prior.v*(height/2-7)});
 const tip={x:width-pad,y:height/2-value*(height/2-7)};
 points.push(tip);
 const path=points.map((p,i)=>`${i?'L':'M'}${Math.max(pad,Math.min(width-pad,p.x)).toFixed(2)} ${p.y.toFixed(2)}`).join(' ');
 const first=points[0]||tip;
 return {path,fill:`${path} L${tip.x} ${height/2} L${first.x.toFixed(2)} ${height/2}Z`,tip,count:history.length};
}
